import { render, staticRenderFns } from "./alreadyCloth.vue?vue&type=template&id=2d31737e"
import script from "./alreadyCloth.vue?vue&type=script&lang=js"
export * from "./alreadyCloth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports